import { ClientId } from './ClientId';
import { ConfigSchema } from './schemas/configSchema';

export const ClientsConfig: Record<ClientId, () => Promise<ConfigSchema>> = {
  espro: () => import('./clients/espro').then((m) => m.default),
  etyflex: () => import('./clients/etyflex').then((m) => m.default),
  siap: () => import('./clients/siap').then((m) => m.default),
  sanok: () => import('./clients/sanok').then((m) => m.default),
  ekoplast: () => import('./clients/ekoplast').then((m) => m.default),
  generic: () => import('./clients/generic').then((m) => m.default),
  nanochem: () => import('./clients/nanochem').then((m) => m.default),
};
